import {Checkbox, FormControlLabel, Grid, TextField} from "@mui/material"
import {Box} from "@mui/system"
import {FC} from "react"
import {useTranslation} from "react-i18next";

type Props = {
    error: string | undefined,
    section: string | undefined,
    isSection: boolean,
    handleSectionChange: (section: string | undefined) => void,
    handleIsSectionChange: (isSection: boolean) => void,
    isFlow: boolean,
    handleIsFlowChange: (isFlow: boolean) => void,
}
export const EditSectionDetailsComponent: FC<Props> = ({
                                                           isSection,
                                                           handleIsSectionChange,
                                                           section,
                                                           handleSectionChange,
                                                           error,
    isFlow,handleIsFlowChange
                                                       }) => {
    console.log("EditSectionDetailsComponent", isFlow)
    //const {t} = useTranslation()
    return (
        <>
            <Grid xs={6} item>
                <FormControlLabel labelPlacement="start" control={
                    <Checkbox checked={isSection} onChange={() => handleIsSectionChange(!isSection)}/>
                } label={"Sekcja Wrocławska"}/>

            </Grid>
            {isSection && (
                <> <Grid xs={12} item justifyContent="center" justifyItems="center" alignItems="center">
                    <FormControlLabel labelPlacement="start" control={
                        <Checkbox checked={isFlow} onChange={() => handleIsFlowChange(!isFlow)}/>
                    } label={"Sekcja Flow"}/>
                </Grid>
                    <Grid xs={12} item justifyContent="center" justifyItems="center" alignItems="center">
                        <Box display="flex" justifyContent="center">
                            <TextField
                                sx={{width: 300}}
                                error={!!error}
                                helperText={error}
                                label={"Nazwa sekcji"}
                                id="event-name"
                                value={section}
                                onChange={(e) => handleSectionChange(e.target.value)}
                            />
                        </Box>
                    </Grid>
                </>
            )}
        </>
    )
}
